<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="The Illustrated Book Of Edible Plants">
<div class="frontcover">
<img alt="cover image" src="images/cover.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?f6e7336c